import { css } from '@emotion/react';
import { Paragraph, tokens } from '@flysas-tech/commercial-ui';
import { t } from 'i18n';
import { useState } from 'react';
import { formatCurrency } from 'shared';

import { LinkAsButton } from '../atoms';

import { CartItem } from './CartItem';
import { PriceGroup } from './types';

const styles = {
  container: css`
    display: grid;
    gap: ${tokens.dimension['space-4']};
  `,
  type: css`
    margin-bottom: ${tokens.dimension['space-2']};
    font-weight: 700;
    display: flex;
    justify-content: space-between;
  `,
  detailsContainer: css`
    display: flex;
    justify-content: space-between;
    align-items: start;
  `,
  bold: css`
    font-weight: 700;
  `,
  card: css`
    display: flex;
    flex-direction: column;
    gap: ${tokens.dimension['space-3']};
  `,
  prices: css`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  `,
};

type Props = {
  priceList: PriceGroup[];
  pos: string;
  price?: number;
  pointsPrice?: React.ReactNode;
};

export const PriceDetails = ({ priceList, pos, price, pointsPrice }: Props) => {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <>
      <div css={styles.card}>
        <div css={styles.detailsContainer}>
          <LinkAsButton onClick={() => setShowDetails(!showDetails)} data-testid="toggle-cart-details">
            {showDetails
              ? t('common:hideDetails', { defaultValue: 'Hide details' })
              : t('common:showDetails', { defaultValue: 'Show details' })}
          </LinkAsButton>
          {(pointsPrice || price) && (
            <div css={styles.prices}>
              {pointsPrice && pointsPrice}
              <span css={styles.bold}>{price && <div>{formatCurrency(price, pos)}</div>}</span>
            </div>
          )}
        </div>
      </div>

      {showDetails &&
        priceList.map((priceGroup, index) => (
          <div key={`${index}-${priceGroup.label}`} css={styles.container}>
            <Paragraph css={styles.type} color="primary" size="paragraph-3">
              {priceGroup.label}
            </Paragraph>
            {priceGroup.items.map(cartItem => (
              <CartItem key={`${cartItem.value}-${index}`} item={cartItem} pos={pos} />
            ))}
          </div>
        ))}
    </>
  );
};
